import { queryOptions } from '@tanstack/react-query';
import { InsurancesQueryResponseType } from '@/common/queries/selections/insurances/insurancesQuery.type.ts';
import { insurancesQueryFunction } from '@/common/queries/selections/insurances/insurancesQueryFunction.ts';

export const InsurancesDefaultQueryOption = () => {
  return queryOptions({
    queryFn: insurancesQueryFunction,
    queryKey: ['insurances'],
    select: (data) => {
      return data.map((item: InsurancesQueryResponseType) => ({
        value: item.id,
        label: item.name,
      }));
    },
  });
};
